/**
 * @file Client wrapper for the `emailAnalyticsReportRun` callable, "Email
 * now": asks the service to email one stored run to the caller's verified
 * address and settles to an outcome, never throwing. Consumer:
 * `AnalyticsReportRunActions`. The request carries only the run's ids, so the
 * client never names an address.
 */
import { httpsCallable } from 'firebase/functions';

import { functions } from '@/services/firebaseFunctions';
import type { AnalyticsReportRunCallOutcome } from '@/analytics';
import type { AnalyticsReportRunRequest } from '#types';

import { analyticsCallFailure } from './analyticsCallFailure';

export const emailAnalyticsReportRun = async (
  request: AnalyticsReportRunRequest,
): Promise<AnalyticsReportRunCallOutcome> => {
  try {
    const callable = httpsCallable<AnalyticsReportRunRequest, unknown>(
      functions,
      'emailAnalyticsReportRun',
    );
    const { data } = await callable({
      reportId: request.reportId,
      runId: request.runId,
    });
    return typeof data === 'object' &&
      data !== null &&
      'retryAt' in data &&
      typeof data.retryAt === 'string'
      ? { status: 'done', retryAt: data.retryAt }
      : {
          status: 'failed',
          message: 'The email answer arrived in an unexpected shape.',
        };
  } catch (error) {
    return analyticsCallFailure(error);
  }
};
